import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Row, Col, Badge } from 'reactstrap'
import { subscriptionShape } from '../../../lib/shapes'
import { extractExpirationInfo } from '../../../lib/util'
import { ErrorBoundary } from 'components'
import FieldsetItem from '../../../components/FieldsetItem'
import FieldsetItemLarge from '../../../components/FieldsetItemLarge'
import { Tooltip } from '../../../components/index'
import api from '../../../lib/Api'

class SubscriptionSummary extends React.Component {
  static propTypes = {
    subscription: subscriptionShape.isRequired,
    showRebalanceModal: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      setupAdminEmailUserId: null,
    }
  }

  componentDidMount = async () => {
    const { setUpAdminEmail } = this.props.subscription || {}

    if (!!setUpAdminEmail) {
      const response = await api.get(`/profile/search?email=${setUpAdminEmail}`)
      if (!!response.data && response.data.length > 0) {
        const setupAdmin = response.data[0]
        const { id } = setupAdmin || {}
        this.setState({ setupAdminEmailUserId: id })
      }
    }
  }

  render = () => {
    const { subscription } = this.props
    if (!subscription) return null
    const expiration = extractExpirationInfo(subscription, 'YYYY-MM-DD')
    const { setUpAdminEmail, fromSubscriptionIds, payerNetsuiteCustomer } =
      subscription || {}
    const setUpAdminEmailLink =
      !!setUpAdminEmail && !!this.state.setupAdminEmailUserId
        ? `/css-admin/users/${setUpAdminEmail}/${this.state.setupAdminEmailUserId}`
        : null
    return (
      <ErrorBoundary>
        <Row>
          <Col sm={8}>
            <fieldset>
              <legend>Details</legend>
              <Row>
                <Col>
                  <FieldsetItem title="Setup Admin">
                    {setUpAdminEmailLink ? (
                      <Link
                        to={`/css-admin/users/${setUpAdminEmail}/${this.state.setupAdminEmailUserId}`}
                      >
                        {setUpAdminEmail || '-'}
                      </Link>
                    ) : (
                      setUpAdminEmail || '-'
                    )}
                  </FieldsetItem>
                  <FieldsetItem title="From NS Subscriptions">
                    {fromSubscriptionIds.length === 0 && (
                      <Tag color="light" text="None" />
                    )}
                    {fromSubscriptionIds.length > 0 &&
                      fromSubscriptionIds.map(s => (
                        <Tag color="info" key={s} text={s} />
                      ))}
                  </FieldsetItem>
                  <FieldsetItem title="Organization Id">
                    {subscription.organizationId}
                  </FieldsetItem>
                </Col>
                <Col>
                  <FieldsetItem
                    color="none"
                    data={expiration.startDate.formatted}
                    title="Start Date"
                  />
                  <FieldsetItem
                    color={expiration.isExpired ? 'danger' : 'none'}
                    title="Expiration Date"
                  >
                    {expiration.expirationDate.formatted}
                  </FieldsetItem>
                  <FieldsetItem color="none" title="Setup">
                    <SubscriptionStatus
                      expiration={expiration}
                      showRebalanceModal={null}
                      subscription={subscription}
                    />
                  </FieldsetItem>
                </Col>
              </Row>
            </fieldset>
          </Col>
          <Col sm={4}>
            <fieldset>
              <legend>Purchase Customer</legend>
              <FieldsetItem
                data={payerNetsuiteCustomer.nsCustomerId || ''}
                title="NS Customer Id"
              />
              <FieldsetItemLarge
                data={payerNetsuiteCustomer.companyName || ''}
                title="Customer Name"
              />
            </fieldset>
          </Col>
        </Row>
      </ErrorBoundary>
    )
  }
}

const Tag = props => {
  if (!props.text) return null
  return (
    <Badge
      color={props.color}
      onClick={props.onClick}
      style={
        props.onClick
          ? { fontSize: 'initial', cursor: 'pointer' }
          : { fontSize: 'initial' }
      }
    >
      {props.text}
    </Badge>
  )
}

const SubscriptionStatus = props => {
  const { subscription, expiration, showRebalanceModal } = props

  if (expiration.isExpired) return <Tag color="dark" text="Unavailable" />

  if (subscription.outOfBalance) {
    const tooltipMsg = subscription.assignedSkusNotInSubscription
      ? 'Invalid skus provisioned'
      : subscription.tooManySkusProvisioned
      ? 'Too many skus provisioned'
      : '/shrug'
    return (
      <Tooltip title={tooltipMsg}>
        <Tag
          color="danger"
          onClick={showRebalanceModal}
          text="Out of Balance"
        />
      </Tooltip>
    )
  }

  if (subscription.needsConfiguration)
    return <Tag color="warning" text="Needed" />

  return <Tag color="success" text="Complete" />
}

export default SubscriptionSummary



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/SubscriptionSummary.js